export const medium = {
  tension: 280,
  friction: 60,
};

export default {
  tension: 280,
  friction: 100,
};
